// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"86c35b31","300":"ddf8d2ab","480":"1b4c2bb3","635":"423a816d","705":"e5493c72","798":"7944e3c4","864":"38a02a18","909":"687d096f","993":"fc132b1a"}[chunkId] + ".chunk.js";
};